var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140786",
    transform: "translate(345.059 460)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h14v14H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1504",
    transform: "translate(-345.059 -460)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140787",
    fill: "none",
    d: "M345.059 460h14v14h-14z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48288",
    d: "M357.893 461.487v2.6a.583.583 0 0 1-.583.583h-2.625a.583.583 0 0 1-.583-.671.613.613 0 0 1 .613-.5h1.254a5.25 5.25 0 0 0-9.13 2.975.583.583 0 0 1-.583.525.583.583 0 0 1-.584-.641 6.417 6.417 0 0 1 11.054-3.763v-1.137a.583.583 0 0 1 .671-.583.612.612 0 0 1 .5.613Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48289",
    d: "M346.226 472.512v-2.6a.583.583 0 0 1 .583-.583h2.625a.583.583 0 0 1 .583.671.612.612 0 0 1-.613.5h-1.253a5.25 5.25 0 0 0 9.125-2.975.583.583 0 0 1 .583-.525.583.583 0 0 1 .583.642 6.417 6.417 0 0 1-11.049 3.758v1.137a.583.583 0 0 1-.671.583.612.612 0 0 1-.5-.613Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBlue);
export default __webpack_public_path__ + "static/media/Refresh-blue.3936aee7c4ce9402a694bb0cd38bf338.svg";
export { ForwardRef as ReactComponent };